module.exports = __webpack_public_path__ + "img/star_02.279f9964.png";